<template>
    <div>
        <h2>{{ trans('resources.activity-summary.title') }}</h2>
        <v-form v-model="validForm">
            <v-row class="mb-4 mt-4">
                <v-col>
                    <item-selector 
                        :label="trans('resources.activity-summary.resource')"
                        v-model="res"
                        v-bind="{ disabled, clearable:true, loading}"
                        item-text="name" 
                        item-key="id" 
                        action="/resources/list"
                        :rules="rules.required"
                        prepend-icon="person"
                    >
                        <template v-slot:selection="{ item }">
                            <v-chip>{{ item.name }}</v-chip>
                        </template>
                        <template v-slot:item="{ item }">       
                            <v-chip>{{ item.name }}</v-chip>
                        </template>
                    </item-selector>
                </v-col>

                <v-col>
                    <v-text-field 
                        v-model="dateFrom" 
                        :label="trans('resources.activity-summary.start_date')"
                        type="date"
                        :rules="rules.date"
                        prepend-icon="date_range" 
                        clearable
                        :loading="loading"
                        />
                </v-col>
               
                <v-col>
                    <v-text-field 
                        v-model="dateTo" 
                        :label="trans('resources.activity-summary.end_date')"
                        type="date"
                        :rules="rules.end_date"
                        prepend-icon="date_range" 
                        clearable
                        :loading="loading"
                        />
                </v-col>

                <v-col>
                    <item-selector 
                        :label="trans('resources.activity-summary.project')"
                        v-model="pro"
                        v-bind="{ clearable:true}"
                        item-text="name" 
                        item-key="id" 
                        action="/projects/list"
                        :extra-params="{ resource_id: res?.id }"
                        prepend-icon="work"
                        :loading="loading"
                    >
                        <template v-slot:selection="{ item }">
                            <v-chip>{{ item | projectName }}</v-chip>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-chip>{{ item | projectName }}</v-chip>
                        </template>
                    </item-selector>
                </v-col>
            </v-row>


            <v-row class="mb-4">
                <v-col class="text-right">
                    <v-btn color="info" :disabled="!canSubmit" :href="formAction">
                        <v-icon left>send</v-icon>
                        {{trans('common.submit') }}
                    </v-btn>
                </v-col>
            </v-row>
            
        </v-form>

        <v-data-table
            v-if="activities"
            :headers="headerTable"
            :items="dataTable"
            class="main-table elevation-1 mr-3 mt-6"
            :multiSort="true"
            item-key="key"
            :items-per-page="itemPerPage"
            :page.sync="page"
            dense
            show-expand
            :sort-by="['date']"
            :sort-desc="[false]"
        >

            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="4" :class="['expanded-row']" style="padding:0">
                    <v-data-table
                        :headers="headerTaskTable"
                        :items="item.subtasks"
                        class="secondary-table elevation-1"
                        item-key="subtask_id"
                        :hide-default-footer="true"
                        :items-per-page="item.subtasks.lenght"
                        dense
                    >
                        <template v-slot:item.subtask_id="{ item }">
                            <!-- è un escamotage grafica con lo scopo di rendere le colonne di questa seconda tabella uguali alla tabella principale -->
                        </template>

                        <template v-slot:item.name="{ item }">
                            <v-chip color="amber" class="mt-2 mb-2">{{ item.task }}</v-chip> {{ item.name }}
                        </template>
                        <template v-slot:item.hours="{ item }">
                            {{ item.hours | hours }}
                        </template>
                    </v-data-table>
                </td>
            </template>

            <template v-slot:item.hours="{ item }">
                {{ item.hours | hours }}
            </template>

            <template v-slot:body.append>
                <tr class="total-row">
                    <td></td> 
                    <td></td> 
                    <td class="text-right font-weight-bold">{{ trans('resources.activity-summary.total_hours') }}</td>
                    <td class="font-weight-bold">{{ totalHours | hours }}</td>
                </tr>
            </template>


        </v-data-table>

    </div>

</template>

<script>
    import moment from 'moment';
    export default {
        name: "activity-summary",
        props: {
            resource: {
                type: Object,
                required: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            start_date: {
                type: String,
                required: false,
            },
            end_date: {
                type: String,
                required: false,
            },
            project: {
                type: Object,
                required: false,
            },
            activities: {
                required: false,
            }
        },
        data() {
            let res = this.resource;
            let dateTo = this.end_date;
            let dateFrom = this.start_date;
            let pro = this.project;

            return {
                res,
                validForm: true,
                loading:false,
                dateTo,
                dateFrom,
                pro,
                itemPerPage:50,
                page:1,

                rules: {
                    required: [(v) => !!v || trans('validation.required', {attribute: trans('resources.activity-summary.resource')})],
                    date: [(v) => ((v == null || moment(v).isValid())) || trans('validation.date', {attribute: trans('resources.activity-summary.start_date')})],
                    end_date: [(v) => (v == null || (moment(v).isValid(v) && moment(v).isSameOrAfter(this.dateFrom))) || trans('validation.after_or_equal', {attribute: trans('resources.activity-summary.end_date'), date: (this.dateFrom ? moment(this.dateFrom).format("DD/MM/YYYY") : trans('resources.activity-summary.start_date'))})],
                },
            };
        },
        methods: {
            getProjectIndex(list, id, date) {
                for(let i = 0; i < list.length; i++) {
                    if(list[i].id == id && list[i].date == moment(date).format("DD/MM/YYYY")) 
                        return i;
                }
                return -1;
            }
        },
        computed: {
            canSubmit() {
                return this.validForm;
            },
            formAction() {
                let baseURL = '/resources/activity-summary';
                let params = new URLSearchParams();

                if (this.res?.id) params.append("resource_id", this.res.id);
                if (this.pro?.id) params.append("project_id", this.pro.id);
                if (this.dateFrom) params.append("start_date", this.dateFrom);
                if (this.dateTo) params.append("end_date", this.dateTo);

                return `${baseURL}?${params.toString()}`;
            },
            headerTable() {
                return [
                    { text: trans('resources.activity-summary.date'), width: "15%", value: 'date' },
                    { text: trans('resources.activity-summary.project'), width: "60%", value: 'project' },
                    { text: trans('resources.activity-summary.hours'), width: "20%", value: 'hours' },
                ];
            },
            headerTaskTable() {
                return [
                    { text: "", value: 'subtask_id', sortable: false},
                    { text: trans('resources.activity-summary.activities'), width: "60%", value: 'name' },
                    { text: trans('resources.activity-summary.hours'), width: "20%", value: 'hours' },
                ];
            },
            dataTable() {
                let list = new Array;
                console.log(this.activities);

                for(let i = 0; i < this.activities.length; i++) {
                    let index = this.getProjectIndex(list, this.activities[i].subtask.task.project.id, this.activities[i].date);

                    if(index >= 0) {
                        list[index].hours += parseFloat(this.activities[i].hours);
                        list[index].subtasks.push({
                            subtask_id: this.activities[i].subtask.id + "_" + Date.now() + Math.floor(Math.random() * 1000),
                            name: this.activities[i].subtask.name,
                            task: this.activities[i].subtask.task.name,
                            hours: parseFloat(this.activities[i].hours),
                        });
                    }
                    else {
                        list.push({
                            id: this.activities[i].subtask.task.project.id,
                            key: this.activities[i].subtask.task.project.id + "_" + this.activities[i].date,
                            date: moment(this.activities[i].date).format("DD/MM/YYYY"),
                            project: this.activities[i].subtask.task.project.name,
                            hours: parseFloat(this.activities[i].hours),
                            subtasks: [
                                {
                                    subtask_id: this.activities[i].subtask.id + "_" + Date.now() + Math.floor(Math.random() * 1000),
                                    name: this.activities[i].subtask.name,
                                    task: this.activities[i].subtask.task.name,
                                    hours: parseFloat(this.activities[i].hours),
                                },
                            ],
                        });
                    }
                }
                return list;
            },
            totalHours() {
                if (!this.dataTable) return 0;
                return this.dataTable.reduce((sum, item) => sum + parseFloat(item.hours), 0);
            }
        },
        filters: {
            hours: function(v) {
                if (!v) return '0.00 h'
                v = v.toFixed(2);
                v = v.toString()
                return v + ' h';
            },
            projectName: function(item) {
                let jobCode = ( item?.customer?.code && item?.code) ? item.customer.code + '.' + item.code + " ": '';
                console.log(item);
                return jobCode + item?.name;
            }
        },
        watch: {
            res(newVal, oldVal) {
                this.pro = null;
            }
        }
    }
</script>

<style>
/* Personalizzazione della classe espansa personalizzata */
.expanded-row {
  background-color: #ffffff !important; /* Rimuove il gradiente e usa un colore solido */
  background-image: none !important; /* Rimuove il gradiente */
  color: #333333; /* Colore del testo personalizzato */
}

.main-table th{
    background-color: #2196f3 !important;
    color:#ffffff !important;
}
/* .main-table td{
    padding-top:5px !important;
    padding-bottom:5px !important;
} */

.main-table td:first-child,
.main-table th:first-child {
  width: 5% !important; /* Modifica la percentuale in base alle esigenze */
  min-width: 50px; /* Imposta un minimo per evitare che si rimpicciolisca troppo */
  text-align: center;
}

.secondary-table th{
    background-color: #82bff5 !important;
    color:#000000 !important;
}
.secondary-table td{
    background-color: #f5f5f5 !important;
}
.secondary-table td:first-child,
.secondary-table th:first-child {
  width: 20% !important; /* Modifica la percentuale in base alle esigenze */
  min-width: 50px; /* Imposta un minimo per evitare che si rimpicciolisca troppo */
  text-align: center;
}
.total-row {
    background-color: #f0f8ff; /* colore di sfondo azzurro chiaro */
    font-weight: bold;           /* testo in grassetto */
}
.total-row td {
    border-top: 2px solid #2196f3; /* opzionale: linea sopra la riga del totale */
}

</style>